// var $ = require("jquery");
// var $ = jQuery;

// includes method polyfill for IE11
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

var objectFitVideos = require("object-fit-videos");
// var menuAim = require("jquery-menu-aim");

objectFitVideos();

let fitvids = require("fitvids");
fitvids(".basic-content");
fitvids('.columned-content__column');

var LazyLoad = require("vanilla-lazyload");

if (
    typeof window.getComputedStyle(document.body).mixBlendMode === "undefined"
) {
    document.body.className += " mix-blend-mode-no";
}

function isTouchDevice() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}

if (isTouchDevice()) {
    $("body").addClass("is-touch-device");
} else {
    $("body").addClass("no-touch");
}

// icons

$(".icon--animate").each(function () {
    var hover = false;
    if ($(this).hasClass("icon--animate-hover")) {
        hover = true;
    }

    var autoplay = false;
    if ($(this).hasClass("icon--animate-autoplay")) {
        autoplay = true;
    }

    (function (elm, data) {
        var animation = lottie.loadAnimation({
            container: elm,
            renderer: "svg",
            loop: false,
            autoplay: autoplay,
            path: data,
        });

        // show last frame if not autplaying
        if (!autoplay) {
            animation.addEventListener("data_ready", function (anim) {
                animation.goToAndStop(animation.totalFrames - 1, true);
            });
        }

        if (hover) {
            $(elm).on({
                mouseenter: function (e) {
                    if (animation.loop) {
                        animation.play();
                    } else {
                        animation.loop = true;
                        animation.play();
                    }
                },
                mouseleave: function (e) {
                    animation.goToAndStop(animation.totalFrames - 1, true);
                },
            });
        }
    })(this, $(this).data("file"), hover, autoplay);
});

// match height

// require("jquery-match-height");
// let matchHeight = require('./libs/MatchHeight.js');
// console.log(matchHeight);
$(".blocks__block-content").matchHeight();
$(".card-list__card-content").matchHeight();
$(".locations-list__location").matchHeight();
$(".split-content__content-section").matchHeight();
$(".people-list--cta .people-list__person-details").matchHeight();
$('.featured-job-listing__job-content').matchHeight();
$('.phases__item').matchHeight();

// quote flip

$(".blocks_block--quote_block").on({
    mouseenter: function (e) {
        $(this)
            .find(".blocks__wysiwyg-content")
            .hide();
        $(this)
            .find(".blocks__block-quote")
            .show();
    },
    mouseleave: function (e) {
        $(this)
            .find(".blocks__wysiwyg-content")
            .show();
        $(this)
            .find(".blocks__block-quote")
            .hide();
    },
});

// case studies

$(".case-studies-list__case-studies a").on("click", function (e) {
    e.preventDefault();
    var tgt = $(this)
        .attr("href")
        .replace(/^#/, ""),
        thisCaseStudy = $(this).children(".case-studies-list__case-study");

    // already open, close it
    if (thisCaseStudy.hasClass("case-studies-list__case-study--active")) {
        thisCaseStudy.removeClass("case-studies-list__case-study--active");
        $("#" + tgt).hide();
        $(".case-studies-list__case-studies-contents").hide();

        // not open yet. close all others, then open it
    } else {
        $(".case-studies-list__case-study").removeClass(
            "case-studies-list__case-study--active",
        );
        $(".case-studies-list__case-study-content").hide();
        $(".case-studies-list__case-studies-contents").hide();

        thisCaseStudy.addClass("case-studies-list__case-study--active");
        $("#" + tgt).show();
        $(".case-studies-list__case-studies-contents").show();

        $("html, body").animate({
                scrollTop: $("#" + tgt).offset().top - 250
            },
            600,
        );
    }
});

$(".case-studies-list__case-studies-toggle").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({
            scrollTop: $(".case-studies-list__case-studies").offset().top - 225
        },
        600,
    );
    $(".case-studies-list__case-study--active").removeClass(
        "case-studies-list__case-study--active",
    );
    $(".case-studies-list__case-studies-contents").hide();
});

// open all external links in new window

$('a[href^="htt"]').each(function () {
    var a = new RegExp("/" + window.location.host + "/");
    if (!a.test(this.href)) {
        $(this).on("click", function (e) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, "_blank");
        });
    }
});

// quotes rotation

$(".quotes__control").on("click", function (e) {
    e.preventDefault();

    var direction = $(this)
        .attr("href")
        .replace(/^#/, ""),
        quotes = $(this)
        .closest(".quotes")
        .find(".quotes__quote"),
        activeQuote = quotes.filter(".quotes__quote--active");

    if (direction == "next") {
        var nextQuote = activeQuote.next(".quotes__quote");
        if (!nextQuote.length) {
            nextQuote = quotes.eq(0);
        }

        activeQuote.removeClass("quotes__quote--active animation-done loaded");
        nextQuote.addClass("quotes__quote--active");

        runAnimation(nextQuote.attr("data-animated"), nextQuote);
    } else {
        var prevQuote = activeQuote.prev(".quotes__quote");
        if (!prevQuote.length) {
            prevQuote = quotes.last();
        }

        activeQuote.removeClass("quotes__quote--active animation-done loaded");
        prevQuote.addClass("quotes__quote--active");

        runAnimation(prevQuote.attr("data-animated"), prevQuote);
    }
});

// tweets rotation

$(".tweets__control").on("click", function (e) {
    e.preventDefault();

    var direction = $(this)
        .attr("href")
        .replace(/^#/, ""),
        tweets = $(this)
        .closest(".twitter-feed")
        .find(".twitter-feed__tweet"),
        activeTweet = tweets.filter(".twitter-feed__tweet--active");

    if (direction == "next") {
        var nextTweet = activeTweet.next(".twitter-feed__tweet");
        if (!nextTweet.length) {
            nextTweet = tweets.eq(0);
        }

        activeTweet.removeClass("twitter-feed__tweet--active");
        nextTweet.addClass("twitter-feed__tweet--active");
    } else {
        var prevTweet = activeTweet.prev(".twitter-feed__tweet");
        if (!prevTweet.length) {
            prevTweet = tweets.last();
        }

        activeTweet.removeClass("twitter-feed__tweet--active");
        prevTweet.addClass("twitter-feed__tweet--active");
    }
});

// nav stuff

// show sticky nav

$(window).on("scroll", function (e) {
    var scrollTop = $(window).scrollTop();

    if (scrollTop >= 70) {
        $("body").addClass("show-sticky");
    } else {
        $("body").removeClass("show-sticky");
    }
});

// show mobile nav for primary nav toggle

$(".site-header__primary-nav-toggle a").on("click", function (e) {
    e.preventDefault();
    $("body").addClass("show-mobile-nav");
});

// sticky nav toggle opens mobile or utility based on screen size

$(".site-header__sticky-nav-toggle a").on("click", function (e) {
    e.preventDefault();

    if ($("body").width() < 1080) {
        $("body").addClass("show-mobile-nav");
    } else {
        $("body").toggleClass("show-utility-nav");
    }
});

// mobile nav toggle always just closes mobile nav

$(".site-header__mobile-nav-toggle a").on("click", function (e) {
    e.preventDefault();
    $("body").removeClass("show-mobile-nav");
});

//check depth 1 sub menu position. if off screen offset it
$('#menu-primary-nav .menu-item--depth-0').on('mouseenter', function () {
    let subMenu = $(this).find(".sub-menu");
    if (subMenu.length > 0) {
        let rect = subMenu[0].getBoundingClientRect();
        if (rect.right > $(window).width()) {
            // subMenu.addClass('right-offset');
            subMenu.css({
                'left': 'auto',
                'right': 0,
                'transform': 'none',
            });
        }
    }
})

// // 3rd level desktop nav
$("#menu-primary-nav .menu-item--depth-0 > .sub-menu .menu-item-has-children").on(
    "mouseenter",
    function () {

        if ($(this).find('.sub-menu').length > 0) {
            $(this).parent('.sub-menu').addClass("active");
            $(".sub-menu__caret").css("opacity", "1");
        }
    },
);

$("#menu-primary-nav .menu-item--depth-0 > .sub-menu .menu-item-has-children").on(
    "mouseleave",
    function () {
        $(this).closest('.sub-menu').removeClass("active");
        $(".sub-menu__caret").css("opacity", "0");
    },
);

// Menu Aim

$("#menu-primary-nav .menu-item--depth-0 > .sub-menu").menuAim({
    rowSelector: ".menu-item--depth-1",
    subMenuDirection: "right",
    activate: function (row) {
        $(row).addClass("hover");

        let y = $(row).position().top + $(row).height() / 2;

        if ($(row).hasClass("hover")) {
            setTimeout(function () {
                $(".sub-menu__caret").css({
                    transform: "translateY(" + y + "px)",
                });
            }, 100);
        }

        // Calc level 2 sub menu based on height of level 3 sub menu
        const currentHeight = $(row)
            .parent(".sub-menu")
            .outerHeight();
        if ($(row).children(".sub-menu").length > 0) {
            const childMenuHeight = $(row).children(".sub-menu")[0].scrollHeight;

            if (childMenuHeight > currentHeight) {
                $(row)
                    .parent(".sub-menu")
                    .css("height", childMenuHeight);
            } else {
                $(row)
                    .parent(".sub-menu")
                    .css("height", "auto");
            }
        }
    },

    deactivate: function (row) {
        $(row).removeClass("hover");
    },

    exitMenu: function (row) {
        $(row)
            .closest(".sub-menu")
            .find(".menu-item.hover")
            .removeClass("hover");
        $(row).css("height", "auto");

        return true;
    },
});

// Add Sub Menu Caret
let caret = $('<span class="sub-menu__caret">');
$("#menu-primary-nav .menu-item--depth-0").each(function () {
    if ($(this).children('.sub-menu').children('li').children('.sub-menu').length > 0) {
        $(this).children(".sub-menu").addClass('has-caret')
            .append(caret);

    }
})

// split content

var splitContentSections = $(".no-touch .split-content__content-section");
if (splitContentSections.length) {
    var splitContentSectionsWrapper = $(".split-content__content-section").parent(
        ".split-content__content-sections",
    );

    splitContentSections.on("mouseenter", function (e) {
        if (window.innerWidth > 991) {
            // set inactive on other
            $(splitContentSections)
                .removeClass("split-content__content-section--active")
                .addClass("split-content__content-section--inactive");

            // activate this one
            $(this).addClass("split-content__content-section--active");
        }
    });

    // remove active AND inactive classes when we mouse out of the section
    splitContentSectionsWrapper.on("mouseleave", function (e) {
        if (window.innerWidth > 991) {
            $(splitContentSections)
                .removeClass("split-content__content-section--active")
                .removeClass("split-content__content-section--inactive");
        }
    });
}

// map stuff

$(function () {
    initMap();
});

var initMap = function () {
    var map;

    function new_map($el) {
        // vars
        var latlng = new google.maps.LatLng(38.9016974, -77.04292629999998);
        var args = {
            zoom: 14,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            styles: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#2d4163",
                    }, ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off",
                    }, ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575",
                    }, ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#2d4163",
                    }, ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry",
                    stylers: [{
                        color: "#757575",
                    }, ],
                },
                {
                    featureType: "administrative.country",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e",
                    }, ],
                },
                {
                    featureType: "administrative.land_parcel",
                    stylers: [{
                        visibility: "off",
                    }, ],
                },
                {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd",
                    }, ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575",
                    }, ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8a8a8a",
                    }, ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575",
                    }, ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#264e76",
                    }, ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#3d3d3d",
                    }, ],
                },
            ],
            zoomControl: true,
        };

        map = new google.maps.Map($el[0], args);

        $(window).on("resize", function () {
            google.maps.event.trigger(map, "resize");
        });

        // add a markers reference
        map.markers = [];

        refresh_markers($el, map);

        return map;
    }

    function refresh_markers($el, map) {
        // remove all markers
        for (var i = 0; i < map.markers.length; i++) {
            map.markers[i].setMap(null);
        }
        map.markers = [];

        // select markers in div that gets refreshed by facetwp
        var $markers = $(".location-page__map .marker");

        // add markers
        $markers.each(function () {
            add_marker($(this), map);
        });

        center_map(map);
    }

    var openInfoWindow = null;

    function add_marker($marker, map) {
        // create marker
        var latlng = new google.maps.LatLng(
            $marker.attr("data-lat"),
            $marker.attr("data-lng"),
        );
        var icon = {
            url: $marker.attr("data-marker-image"),
            size: new google.maps.Size(32, 32),
            scaledSize: new google.maps.Size(32, 32),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(32, 32),
        };
        var marker = new google.maps.Marker({
            position: latlng,
            icon: icon,
            map: map,
            optimized: false,
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, "click", function () {
                if (openInfoWindow) {
                    openInfoWindow.close();
                }
                openInfoWindow = infowindow;
                infowindow.open(map, marker);
            });
        }
    }

    function center_map(map) {
        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(
                marker.position.lat(),
                marker.position.lng(),
            );
            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(14);

            // fit to bounds
        } else {
            map.fitBounds(bounds);
        }
    }

    if ($(".location-page__map").length) {
        $(".location-page__map").each(function () {
            var map = new_map($(this).find(".map"));
        });
    }
};

require("gsap");
var SplitText = require("./libs/SplitText.js");
var imagesLoaded = require("imagesloaded");
imagesLoaded.makeJQueryPlugin($);
var scrollMonitor = require("scrollMonitor");
$(document).ready(function () {
    // shuffle quotes
    var randomizedQuotes = $(".hero__headline-line-option")
        .not(".hero__headline-line-option--active")
        .sort(function () {
            return Math.round(Math.random()) - 0.5;
        });
    $(".hero__headline-line-option")
        .not(".hero__headline-line-option--active")
        .remove();
    $(".hero__headline-line-option--active").after(randomizedQuotes);

    $("[data-animated]").each(function () {

        var element = $(this),
            animationName = $(this).attr("data-animated"),
            elementWatcher = scrollMonitor.create($(this)[0]);
        elementWatcher.enterViewport(function () {
            if ($(element).hasClass("animation-done") == false) {
                runAnimation(animationName, element);
            }
        });
    });

    initNewsFacets();
    initPeopleFacets();
});

var runAnimation = function (animationName, elem) {
    if (animationName == "slide-in-opposite") {
        var container = $(elem),
            image = $(elem).find(".hero__image"),
            contentBg = $(elem).find(".hero__content-background"),
            content = $(elem).find(".hero__content");

        $(container).imagesLoaded({
            background: true
        }, function () {
            $(container).addClass("loaded");
            var firstRun = true;
            var tl = new TimelineLite({
                onComplete: loadText,
            });
            var split = new SplitText($(".hero__headline-line-option--active"), {
                type: "chars",
            });
            //TweenMax.set(split.chars, {y: 100});
            tl.set(image[0], {
                    transform: "translateX(-100vw)"
                })
                .set(contentBg[0], {
                    transform: "translateX(100vw)"
                })
                //.set($('.hero__headline-line--static_text .static-text'), {y:100})
                .to(image[0], 0.75, {
                    transform: "translateX(0vw)",
                    ease: Power0.easeIn,
                })
                .to(contentBg[0], 0.75, {
                    transform: "translateX(0vw)",
                    ease: Power0.easeInOut,
                })
                .from(content[0], 0.25, {
                    opacity: 0,
                    bottom: "+=30px"
                });

            if ($(".hero__content-line")) {
                tl.to($(".hero__content-line"), 0.25, {
                    height: "125%",
                    ease: Power0.easeInOut,
                });
            }

            function loadText() {
                if ($(container).find(".hero__headline-line--rotating_text")) {
                    var split = new SplitText($(".hero__headline-line-option--active"), {
                        type: "chars",
                    });
                    var tl2 = new TimelineLite({
                        onComplete: rotateText,
                    });
                    tl2.to($(".hero__headline-line--static_text .static-text"), 0.75, {
                        y: 0,
                    });
                }
            }

            function rotateText() {
                if (firstRun == true) {
                    loadNextQuote();
                } else {
                    $(".hero__headline-line-option--active").css({
                        opacity: 1
                    });
                    var tl3 = new TimelineLite({
                        onComplete: loadNextQuote,
                    });
                    tl3.insert(TweenMax.staggerTo(split.chars, 0.25, {
                        y: 0
                    }, 0.15));
                }
            }

            function loadNextQuote() {
                var timeOutSpeed = 1750;
                if (firstRun) {
                    timeOutSpeed = 0;
                }

                setTimeout(function () {
                    // fade out active quote
                    $(".hero__headline-line-option--active").animate({
                            opacity: 0
                        },
                        1,
                        function () {
                            // move active to next quote
                            split.revert();
                            // find random instead of next
                            // var selector = $('.hero__headline-line--rotating_text .hero__headline-line-option'),
                            //     randomIndex = Math.floor(Math.random() * selector.length);
                            // var next = selector[randomIndex];

                            var next = $(
                                ".hero__headline-line--rotating_text .hero__headline-line-option",
                            ).first();
                            if (
                                $(".hero__headline-line-option--active").next(
                                    ".hero__headline-line-option",
                                ).length
                            ) {
                                next = $(".hero__headline-line-option--active").next(
                                    ".hero__headline-line-option",
                                );
                            }

                            $(".hero__headline-line-option--active").removeClass(
                                "hero__headline-line-option--active",
                            );
                            $(next).addClass("hero__headline-line-option--active");
                            split = new SplitText($(next), {
                                type: "chars"
                            });
                            TweenMax.set(split.chars, {
                                y: 100
                            });
                            // rotateText
                            firstRun = false;
                            rotateText();
                        },
                    );
                }, timeOutSpeed);
            }
        });
    }

    if (animationName == "slide-in-quotes") {
        var container = $(elem),
            background = $(elem).find(".quotes__quote-content-background"),
            text = $(elem).find(".quotes__quote-content"),
            image = $(elem).find(".quotes__quote-photo");

        $(container).imagesLoaded({
            background: true
        }, function () {
            $(container).addClass("loaded");
            var tl = new TimelineLite();
            tl.set(background[0], {
                    transform: "translateX(-100vw)"
                })
                .set(text[0], {
                    transform: "translateX(-100vw)"
                })
                .set(image[0], {
                    maxWidth: "0"
                })
                .to(background[0], 0.25, {
                    transform: "translateX(0vw)",
                    ease: Power0.easeInOut,
                })
                .to(text[0], 0.25, {
                    transform: "translateX(0vw)",
                    ease: Power0.easeInOut,
                })
                .to(image[0], 0.25, {
                    maxWidth: "100%",
                    ease: Power0.easeInOut
                });

            if ($(elem).find(".quotes__quote-content-line")) {
                tl.to($(elem).find(".quotes__quote-content-line"), 1.0, {
                    height: "125%",
                    ease: Power0.easeInOut,
                });
            }
        });
    }

    if (animationName == "fade-in") {
        var container = $(elem);
        var tl = new TimelineLite();
        tl.set(container[0], {
                opacity: "0"
            })
            .delay(0.25)
            .to(container[0], 0.3, {
                opacity: "1",
                ease: Power0.easeInOut
            });
    }

    if (animationName == "counter") {

        var container = $(elem),
            direction = "up",
            startVal = 0,
            endVal = parseInt($(container).text().replace(/\$|,/g, '')),
            appendText = "",
            prependText = "",
            finalVal = $(container).text();

        if ($(container).text().includes("+")) {
            appendText = "+";
        }

        if ($(container).text().includes("%")) {
            appendText = "%";
        }

        if ($(container).text().includes("$")) {
            prependText = "$";
        }

        if ($(container).text().substr(-2) == "MB") {
            appendText = "MB";
        }

        if ($(container).text().substr(-1) == "M") {
            appendText = 'M';
        }

        if ($(container).text().substr(-1) == "B") {
            appendText = 'B';
        }

        // change direction if necessary
        if ($(container).hasClass("blocks__block-stat--count-down")) {
            direction = "down";
            startVal = 9999;
        }

        var counter = {
                countVal: startVal
            },
            counterDisplay = $(container);

        TweenLite.to(counter, 2, {
            countVal: endVal,
            roundProps: "countVal",
            onUpdate: updateHandler,
            ease: Power0.easeInOut,
            onComplete: completeHandler,
        });

        function updateHandler() {
            counterDisplay.text(prependText + counter.countVal + appendText);
        }

        function completeHandler() {
            counterDisplay.text(finalVal);
        }
    }

    $(elem).addClass("animation-done");
};

function debounce(fn, threshold) {
    var timeout;
    return function debounced() {
        if (timeout) {
            clearTimeout(timeout);
        }

        function delayed() {
            fn();
            timeout = null;
        }
        setTimeout(delayed, threshold || 100);
    };
}

// lazyload
var myLazyLoad = new LazyLoad({
    elements_selector: ".lazyload",
    callback_enter: function () {
        $(window).trigger("resize");
    },
    callback_set: function () {
        $(window).trigger("resize");
    },
    callback_load: function () {
        $(window).trigger("resize");
    },
});

var updateUrlParameter = function (e, r, a) {
        var t = e.indexOf("#"),
            i = -1 === t ? "" : e.substr(t);
        e = -1 === t ? e : e.substr(0, t);
        var s = new RegExp("([?&])" + r + "=.*?(&|$)", "i"),
            p = -1 !== e.indexOf("?") ? "&" : "?";
        a
            ?
            (e = e.match(s) ?
                e.replace(s, "$1" + r + "=" + a + "$2") :
                e + p + r + "=" + a) :
            ("?" ===
                (e = e.replace(new RegExp("([?&]?)" + r + "=[^&]*", "i"), "")).slice(
                    -1,
                ) && (e = e.slice(0, -1)),
                -1 === e.indexOf("?") && (e = e.replace(/&/, "?"))),
            pushUrl(e + i);
    },
    pushUrl = function (e) {
        if (history.pushState) {
            var r = e;
            window.history.pushState({
                path: r
            }, "", r);
        }
    };

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// filter job listing
function jobListingFilter() {
    var urlLocation = getParameterByName('filter-locations');
    var urlDepartments = getParameterByName('filter-department');

    $('#job-listing__filter-locations').on('change', function () {
        let val = $('#job-listing__filter-locations').val();
        let type = $(this).attr('name');

        updateUrlParameter(window.location.href, type, val);

        urlLocation = getParameterByName('filter-locations');
        clearFilters(urlLocation, urlDepartments);

        $(".job-listing__job").each(function () {
            let jobLocation = $(this).data('location');
            let jobDepartment = $(this).data('department');

            if (val == '') {
                if (urlDepartments != '' && urlDepartments == jobDepartment) {
                    $(this).show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                } else if (urlDepartments != '' && urlDepartments != jobDepartment) {
                    $(this).hide();
                    $(this).addClass('hidden');
                    $(this).removeClass('visible');
                } else {
                    $('.job-listing__job').show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                }
                return;
            }

            if (urlDepartments == '') {
                if (jobLocation != val) {
                    $(this).hide();
                    $(this).addClass('hidden');
                    $(this).removeClass('visible');
                } else if (jobLocation == val) {
                    $(this).show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                }
            }

            if (urlDepartments != '') {
                if (urlDepartments == jobDepartment && val == jobLocation) {
                    $(this).show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                } else if (jobLocation != val) {
                    $(this).hide();
                    $(this).addClass('hidden');
                    $(this).removeClass('visible');
                }
            }
        })
        checkVisibleJobs();
    })

    $('#job-listing__filter-departments').on('change', function () {
        let val = $('#job-listing__filter-departments').val();
        let type = $(this).attr('name');

        updateUrlParameter(window.location.href, type, val);

        urlDepartments = getParameterByName('filter-departments');
        clearFilters(urlLocation, urlDepartments);

        $(".job-listing__job").each(function () {
            let jobLocation = $(this).data('location');
            let jobDepartment = $(this).data('department');

            if (val == '') {
                if (urlLocation != '' && urlLocation == jobLocation) {
                    $(this).show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                } else if (urlLocation != '' && urlLocation != jobLocation) {
                    $(this).hide();
                    $(this).addClass('hidden');
                    $(this).removeClass('visible');
                } else {
                    $('.job-listing__job').show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                }
                return;
            }

            if (urlLocation == '') {
                if (jobDepartment != val) {
                    $(this).hide();
                    $(this).addClass('hidden');
                    $(this).removeClass('visible');
                } else if (jobDepartment == val) {
                    $(this).show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                }
            }

            if (urlLocation != '') {
                if (urlLocation == jobLocation && val == jobDepartment) {
                    $(this).show();
                    $(this).addClass('visible');
                    $(this).removeClass('hidden');
                } else if (jobDepartment != val) {
                    $(this).hide();
                    $(this).addClass('hidden');
                    $(this).removeClass('visible');
                }
            }
        })
        checkVisibleJobs();
    })

    $('.clear-filter-container .fa-times').on('click', function () {
        $('.clear-filter-container.visible').removeClass('visible');
        $('#job-listing__filter-departments').val('').trigger('change');
        $('#job-listing__filter-locations').val('').trigger('change');

        let type = '';
        let val = '';
        updateUrlParameter(window.location.href, type, val);
    })

    function clearFilters(location, type) {

        if (location != '' || type != '') {
            $('.clear-filter-container').addClass('visible');
        } else if (location == '' && type == '') {
            $('.clear-filter-container').removeClass('visible');
        }
    }

    function checkVisibleJobs() {
        let totalJobs = $('.job-listing__job').length;
        let hiddenNumber = 0;

        $('.job-listing__job').each(function () {
            if ($(this).hasClass('hidden')) {
                hiddenNumber++;
            }
        })
        if (hiddenNumber == totalJobs) {
            $('.job-listing__no-jobs').show();
        } else {
            $('.job-listing__no-jobs').hide();
        }
    }
}
jobListingFilter();

(function () {

    var table = $('#job-listing__list').DataTable({
        'order': [
            [2, 'asc']
        ],
        'paging': false,
    });
    $('#search-input').on('keyup', function () {
        table.search($(this).val()).draw();
    });

})();

function wrapSingleJobLi() {
    $('.job-page__listed-items-item').each(function () {
        $(this).children('li').wrapAll('<ul></ul>');
    })
}

wrapSingleJobLi();

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

function hideFeaturedNews() {
    $(document).on('facetwp-loaded', function () {
        let hide = false;
        if (FWP.facets['industry'] && FWP.facets['industry'].length > 0) {
            hide = true;
        }
        if (FWP.facets['topics'] && FWP.facets['topics'].length > 0) {
            hide = true;
        }
        if (FWP.facets['types'] && FWP.facets['types'].length > 0) {
            hide = true;
        }

        if (hide) {
            $('.news-insights-list__featured-post').hide();
            $('.news-insights-list__featured-post').addClass('hide');
        } else {
            $('.news-insights-list__featured-post').show();
            $('.news-insights-list__featured-post').removeClass('hide');
        }
        $('.news-insights-list__post.hide').each(function (i) {
            let _this = $(this);
            setTimeout(function () {
                _this.removeClass('hide');
            }, 100 * i);
        })
    })
}

hideFeaturedNews();

function expandSearchbar() {
    $('.site-header__utility-nav .search-toggle').on('click', function () {
        let parent = $(this).parent();

        parent.toggleClass('search-active');
        $('.site-header__utility-nav-background').toggleClass('active');

        $(this).siblings('.utility-nav__search-form').find('input').focus();
    })
}

expandSearchbar();

function groupCalloutContent() {
    if ($('.callout-with-content').hasClass('callout-with-content--full')) {
        $('.callout-with-content--full .callout-with-content__content').each(function () {
            let _this = $(this);
            let children = _this.children('p').not('blockquote');
            children.wrapAll('<div class="callout-with-content__content-container" />')
        })
    }
}
groupCalloutContent();

$('.phases__item').on('click', function () {
    $(this).toggleClass('active');
    let additionalContent = $(this).find('.item__additional-content');
    let height = additionalContent[0].scrollHeight;
    additionalContent.toggleClass('active');
    if (additionalContent.hasClass('active')) {
        additionalContent.css('max-height', height);
        $(this).addClass('height-auto');
    } else {
        $(this).removeClass('height-auto');
        additionalContent.css('max-height', 0);
    }
})

function checkNewsSummary() {
    $('.news-insights-list__post-summary').each(function () {
        let height = $(this)[0].scrollHeight;
        let maxHeight = $(this).css('max-height');
        if (height < parseFloat(maxHeight)) {
            $(this).addClass('no-overlay');
        }
    })
}
checkNewsSummary();

var initNewsFacets = function () {
    if ($('.facet-dropdown-container').length) {

        var checkFacetExpanders = function () {
            $('.facetwp-expand').each(function (idx, elem) {
                if ($(elem).text() == '[-]') {
                    $(elem).parents('.facetwp-checkbox').addClass('expanded');
                } else {
                    $(elem).parents('.facetwp-checkbox').removeClass('expanded');
                }
            });
        }

        $('body').on('click', '.facetwp-expand', function () {
            setTimeout(function () {
                checkFacetExpanders();
            }, 10);

        });

        $(document).on('facetwp-loaded', function () {
            checkFacetExpanders();
            if ($('.facetwp-checkbox.checked').length > 0) {
                $('.clear-search').addClass('active');
            } else {
                $('.clear-search').removeClass('active');
            }
            $('.facet-dropdown').each(function (idx, elem) {
                let label = $(this).attr('data-original-label');
                if ($(elem).find('.checked').length) {
                    label = '';
                    $(elem).find('.checked').each(function (ix, checked) {
                        let text = $(checked).clone() //clone the element
                            .children() //select all the children
                            .remove() //remove all the children
                            .end() //again go back to selected element
                            .text().trim();
                        label += text + ', ';
                    });
                    $(elem).find('.label span').text(label.slice(0, -2));
                } else {
                    $(elem).find('.label span').text(label);
                }

            });
        });

    }
}

var initPeopleFacets = function () {
    $(document).on('facetwp-loaded', function () {
        let noFilters = true;
        if (($('.people-list__section-filters').find('.facetwp-search').val() != '' && $('.people-list__section-filters').length > 0) || $('.facetwp-checkbox.checked').length) {
            noFilters = false;
        }
        if (noFilters == false) {
            $('.clear-search').addClass('active');
        } else {
            $('.clear-search').removeClass('active');
        }

        if ($('.hidden-facet-wp-results').length) {
            $('.people-list__section-intro').hide();
            $('.people-list__people [data-post-id]').addClass('hidden');
            $('.hidden-facet-wp-results div').each(function (idx, elem) {
                var visiblePostId = $(elem).attr('data-post-id'),
                    targetElem = $('.people-list__people [data-post-id="' + visiblePostId + '"]');
                if (noFilters == true && targetElem.hasClass('type--md')) {
                    targetElem.addClass('hidden');
                } else {
                    targetElem.removeClass('hidden');
                }
                targetElem.parents('.page-section').find('.people-list__section-intro').show();


            });

            $('.people-list').each(function (idx, elem) {
                if ($(elem).find('.people-listing__person:visible').length <= 0) {
                    $(elem).find('.people-list__people--no-results').show();
                } else {
                    $(elem).find('.people-list__people--no-results').hide();
                }
            });
        }
        personBackgroundShape();
    });
}

// function statAnimation() {
//     let stats = $('.stats-with-content__stat h2');
//     stats.each(function () {
//         runAnimation($(this).attr('data-animation'), $(this));
//         if ($(this).data('append').length > 0) {
//             $(this).append('<span>' + $(this).data('append') + '</span>');
//         }
//     });
// }

// statAnimation();


function loadMoreSearch() {
    $('.search__load-more a').each(function () {
        $(this).on('click', function (e) {
            e.preventDefault();
            $(this).parents('.page-section').find('.hide-load-more').removeClass('hide-load-more');
            personBackgroundShape();
            $(this).hide();
        })
    })
}

loadMoreSearch();

$('.search-header a').on('click', function () {
    let target = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(target).offset().top - 125
    }, 1500);
})

function clearFilters() {
    $('.clear-search').on('click', function () {
        $(this).removeClass('active');
        FWP.reset();
    })
}

clearFilters();

$('#show-all-employees').on('click', function () {
    $('.people-list__people [data-post-id]').removeClass('hidden');
    personBackgroundShape();
    $('html, body').animate({
        scrollTop: $('.people-listing__person.type--md').offset().top - 125,

    }, 1500);
})

function personBackgroundShape() {
    $('.people-listing__person.person--even').removeClass('person--even');
    $('.people-listing__person.person--odd').removeClass('person--odd');

    $('.people-listing__person:visible').each(function (index, ele) {
        if (index % 2 == 0) {
            $(this).addClass('person--even');
        } else {
            $(this).addClass('person--odd');
        }
    })
}

personBackgroundShape();